<ng-container *ngIf="!isLoading else loading">
	<div class="card-title">
		<span translate>order-tracking.card.delivery-status</span>
	</div>
	<div class="delivery-block-portal">
		<div class="delivery-date-grid">
			<span class="delivery-header mobile-hide delivery-header-first" translate>order-tracking.card.delivery-date.rdd</span>
			<span class="delivery-header mobile-hide delivery-header" translate>order-tracking.card.delivery-date.cdd</span>
			<span class="delivery-header" translate>order-tracking.card.delivery-date.first-batch</span>
			<span class="delivery-header delivery-col-highlight" translate>order-tracking.card.delivery-date.last-batch</span>
			<ng-container *ngFor="let order of orders; let i = index">
				<div>
					<mat-icon *ngIf="order.isDelayed || order.isOnTime"
						[svgIcon]="order.isDelayed ? 'md:restore' : 'md:done'"
						[ngClass]="{'delivery-is-delayed': order.isDelayed, 'delivery-in-time': order.isOnTime }">
					</mat-icon>
				</div>
				<a class="pill pill-info pill-clickable" color="primary"
					[routerLink]="['/order-tracking/order/card/', order.supplierOrderNumber, order.supplierOrderItemNumber]">
					{{getOrderName(order)}}
				</a>
				<span class="mobile-hide">{{order.rddWeek | copoDate:'week'}}</span>
				<span class="mobile-hide">{{ checkCddWeekDataWithDatePipe(order.cddWeek) }}</span>
				<span>{{ order.grossFirstBatchInStock ? (order.grossFirstBatchInStock | copoDate:'week') : UNDERSCORE }}</span>
				<span class="delivery-col-highlight">{{ order.grossLastBatchInStock ? (order.grossLastBatchInStock | copoDate:'week') : UNDERSCORE }}</span>
			</ng-container>
		</div>
	</div>
	<div class="delivery-block-mobile">
		<span class="delivery-header delivery-header-first-mobile" translate>order-tracking.card.delivery-date.first-batch</span>
		<span class="delivery-header delivery-col-highlight" translate>order-tracking.card.delivery-date.last-batch</span>
		<ng-container *ngFor="let order of orders; let i = index">
			<a class="pill pill-info pill-clickable" color="primary"
				[routerLink]="['/order-tracking/order/card/', order.supplierOrderNumber, order.supplierOrderItemNumber]">
				{{getOrderName(order)}}
			</a>
			<div>
				<mat-icon *ngIf="order.isDelayed || order.isOnTime"
					[svgIcon]="order.isDelayed ? 'md:restore' : 'md:done'"
					[ngClass]="{'delivery-is-delayed': order.isDelayed, 'delivery-in-time': order.isOnTime }">
				</mat-icon>
			</div>
			<span>{{ order.grossFirstBatchInStock ? (order.grossFirstBatchInStock | copoDate:'week') : UNDERSCORE }}</span>
			<span class="delivery-col-highlight">{{ order.grossLastBatchInStock ? (order.grossLastBatchInStock | copoDate:'week') : UNDERSCORE }}</span>
		</ng-container>
	</div>
	<div class="card-block-footer mobile-hide">
		<button type="button" mat-button color="primary" (click)="viewDetails()">
			<span translate>order-tracking.card.delivery-date.view-details</span>
			<mat-icon iconPositionEnd color="accent" svgIcon="md:chevron_right"></mat-icon>
		</button>
	</div>
</ng-container>
<ng-template #loading>
	<copo-loading-spinner></copo-loading-spinner>
</ng-template>